<template>
    <div>
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h4>Selecionar Pessoa Física</h4>
        <b-button variant="primary" @click="$router.back()" class="d-flex align-items-center">
          <i class="bi bi-arrow-left"></i>
          <span class="ms-2">Voltar</span>
        </b-button>
      </div>
  
      <!-- Filtros -->
      <div class="d-flex mb-3" style="gap: 10px;">
        <input 
          v-model="filters.nome" 
          placeholder="Filtrar por Nome" 
          class="form-control"
          @input="filtrarPessoas"
        />
        <b-button variant="secondary" @click="limparFiltros" class="d-flex align-items-center">
          <i class="bi bi-x-circle"></i>
          <span class="ms-2">Limpar Filtros</span>
        </b-button>
      </div>
  
      <!-- Tabela -->
      <b-table 
        :items="pessoas" 
        :fields="fields" 
        hover
        @row-clicked="selecionarPessoa"
      >
        <template #cell(actions)="row">
          <b-button size="sm" variant="success" class="d-flex align-items-center" @click="selecionarPessoa(row.item)">
            <i class="bi bi-check-circle"></i>
            <span class="ms-2">Selecionar</span>
          </b-button>
        </template>
      </b-table>
  
      <!-- Paginação -->
      <div class="d-flex justify-content-center mt-3" style="gap: 10px;">
        <b-button 
          @click="paginaAnterior" 
          :disabled="paginaAtual === 1"
          variant="light"
          class="d-flex align-items-center"
        >
          <i class="bi bi-chevron-left"></i>
          <span class="ms-2">Anterior</span>
        </b-button>
        <span>Página {{ paginaAtual }} de {{ totalPaginas }}</span>
        <b-button 
          @click="proximaPagina" 
          :disabled="paginaAtual >= totalPaginas"
          variant="light"
          class="d-flex align-items-center"
        >
          <i class="bi bi-chevron-right"></i>
          <span class="ms-2">Próxima</span>
        </b-button>
      </div>
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import { BTable, BButton } from 'bootstrap-vue-next';
  
  export default {
    components: {
      BTable,
      BButton,
    },
    data() {
      return {
        pessoas: [],
        filters: { nome: "" },
        paginaAtual: 1,
        limitePorPagina: 10,
        totalPaginas: 1,
        fields: [
          { key: "nome", label: "Nome", sortable: true },
          { key: "cpf", label: "CPF", sortable: true },
          { key: "actions", label: "Ações" },
        ],
      };
    },
    methods: {
      async carregarPessoas() {
        try {
          const response = await axios.get(`/cadastros/pessoas-fisicas`, {
            params: {
              page: this.paginaAtual,
              limit: this.limitePorPagina,
              nome: this.filters.nome || undefined,
            },
          });
          this.pessoas = response.data.data;
          this.totalPaginas = response.data.totalPages;
        } catch (error) {
          console.error("Erro ao carregar pessoas físicas:", error);
        }
      },
      filtrarPessoas() {
        this.paginaAtual = 1;
        this.carregarPessoas();
      },
      limparFiltros() {
        this.filters.nome = "";
        this.filtrarPessoas();
      },

      selecionarPessoa(pessoa) {
        const returnTo = this.$route.query.returnTo || "/configuracoes/usuarios/novo";
        this.$router.push({
            path: returnTo,
            query: {
            pessoa_fisica_id: pessoa.id,
            pessoa_fisica_nome: pessoa.nome,
            },
        });
    },


      paginaAnterior() {
        if (this.paginaAtual > 1) {
          this.paginaAtual--;
          this.carregarPessoas();
        }
      },
      proximaPagina() {
        if (this.paginaAtual < this.totalPaginas) {
          this.paginaAtual++;
          this.carregarPessoas();
        }
      },
    },
    mounted() {
      this.carregarPessoas();
    },
  };
  </script>
  